import { MDS_COLORS_BACKGROUND_ACCENT_WEAK, MDS_COLORS_INK_ERROR, MDS_COLORS_INK_STRONG, MDS_COLORS_LINE_BORDER_ACCENT, MDS_COLORS_LINE_BORDER_ERROR, } from '@rappi/mustache-b2b-foundations';
import styled from 'styled-components';
export const Wrapper = styled.div `
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px dashed
    ${({ $isDragging, $error }) => {
    if ($isDragging) {
        return MDS_COLORS_LINE_BORDER_ACCENT;
    }
    if ($error) {
        return MDS_COLORS_LINE_BORDER_ERROR;
    }
    return '#868D97';
}};
  border-radius: 16px;
  background-color: ${({ $isDragging }) => ($isDragging ? MDS_COLORS_BACKGROUND_ACCENT_WEAK : '#FBFBFB')};
  transition: background-color 0.3s ease;
`;
export const Content = styled.div `
  width: 100%;
  max-width: 264px;
  display: grid;
  grid-auto-flow: row;
  grid-auto-rows: max-content;
  grid-template-columns: 1fr;
  place-content: center;
  place-items: center;
  gap: 8px;
  overflow: hidden;
  pointer-events: ${({ $isDragging }) => ($isDragging ? 'none' : 'auto')};
`;
export const Title = styled.p `
  color: ${({ $error }) => ($error ? MDS_COLORS_INK_ERROR : MDS_COLORS_INK_STRONG)};
  font-weight: ${({ $semibold }) => ($semibold ? 'bold' : 'normal')};
  font-size: 16px;
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  text-align: center;
`;
export const ErrorMessage = styled(Title) `
  color: ${MDS_COLORS_INK_ERROR};
  text-overflow: initial;
  white-space: normal;
`;
export const RulesContainer = styled.div `
  display: grid;
  grid-auto-flow: row;
  grid-auto-rows: max-content;
  justify-content: center;
  align-items: center;
`;
export const Rule = styled.div `
  font-size: 12px;
  line-height: 20px;
  color: #868d97;
  text-align: center;

  & span:last-child {
    font-weight: bold;
  }
`;
